import styled from "styled-components";
import configAPI from "../../configAPI.json";
import { SessionData, useSessionStore } from "../../hooks/stores/sessionStore";
import { LoadingSpinner } from "../common/LoadingSpinner";
import { TextButton } from "../common/TextButton";

export const TopbarCorner = () => {
  const [sessionData] = useSessionStore<SessionData>();

  return <Container>
    {!sessionData.isLoaded && <LoadingSpinner size={20} color='var(--main-1)' />}
    {sessionData.email ?? <TextButton onClick={() => window.open(configAPI.endpoints.themesPage, '_blank')}>Log in</TextButton>}
  </Container>
}

const Container = styled.div`
  font-family: var(--font-1);
  color: var(--main-2);
  font-size: 12px;

  display: flex;
  align-items: center;
  gap: 10px;
`;